
editPhoneRequestForNotificationController.$inject = ['$scope', '$uibModalInstance', 'companyId', 'site', 'content',
  'links', 'smsContent', 'smsLinks', 'landingPageUrl'];
export function editPhoneRequestForNotificationController($scope, $uibModalInstance, companyId, site, content, links,
  smsContent, smsLinks, landingPageUrl) {

  $scope.submit = submit;
  $scope.cancel = cancel;
  $scope.initialQuestionModel = {
    'text': content,
    'links': links
  };
  $scope.questionModelAccessor = {};
  $scope.questionTextIsEmpty = false;
  $scope.smsTextIsEmpty = false;
  $scope.companyId = companyId;
  $scope.site = site;
  $scope.initialSMSModel = {
    'text': smsContent,
    'links': smsLinks
  };
  $scope.smsModelAccessor = {};
  $scope.landingPageUrl = landingPageUrl;

  function submit() {
    let questionModel = $scope.questionModelAccessor.getModelOfFirstMessage();
    let smsModel = $scope.smsModelAccessor.getModelOfFirstMessage();
    $uibModalInstance.close(
      {
        type: 'edit',
        data: {
          'content': questionModel['text'],
          'links': questionModel['links'],
          'smsContent': smsModel['text'],
          'smsLinks': smsModel['links'],
          'landingPageUrl': $scope.landingPageUrl
        }
      });
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

}
